"use strict";
exports.__esModule = true;
exports.CUSTOMIZE_YOUR_SCHEDULE = void 0;
exports.CUSTOMIZE_YOUR_SCHEDULE = {
    HEADER: 'Customize your schedule',
    BODY: "We'll use the date you pick as your default, but you can change it each month in the Flex app.",
    FIRST_PAYMENT: '1st payment',
    FIRST_PAYMENT_INFO: 'When rent is due',
    SECOND_PAYMENT: '2nd payment',
    SECOND_PAYMENT_INFO: 'Choose date',
    SECOND_PAYMENT_SELECTED_INFO: 'of the month',
    POSITIVE_FEEDBACK_HEADER: 'Smart thinking!',
    POSITIVE_FEEDBACK_BODY: 'Scheduling earlier gives you better control over your cash flow.',
    NEGATIVE_FEEDBACK_HEADER: 'Are you sure?',
    NEGATIVE_FEEDBACK_BODY: 'Scheduling late in the month can make it difficult to get prepared for the following month’s rent.',
    BILL_PAYMENT_FEE: '(includes {{fee}}% bill payment fee)',
    INTEREST_FEE: '(includes {{fee}}% interest)',
    CTA: 'Continue'
};
